import { Box } from '@mui/material';
import classnames from 'classnames';
import { orderBy } from 'lodash';

import { EResourceType, HubsViewMode, ResourceRegionType } from '#shared';

import { DrawerViewType } from '../../ResourceDrawer';
import { BaseCard, classes } from '../BaseCard';
import { StaffWithCounts } from '../components';
import { aggregateResourcesCounts } from '../utils';

import type { HubReportStatus } from '#entities';

type Props = {
  region?: ResourceRegionType;
  onClick?: (id: string, type: DrawerViewType) => void;
  hubsViewMode?: HubsViewMode;
  isEastOverride?: boolean;
} & HubReportStatus;

export const DeviceSpecialistGroupCard = ({
  id,
  staffInfo,
  location: { abbreviation, city, state },
  region,
  onClick,
  hubsViewMode,
  isEastOverride,
}: Props) => {
  const cardLocationClass = `${state}_${city}`
    .replaceAll(/\W/g, '_')
    .toUpperCase();

  const isEast =
    typeof isEastOverride === 'boolean'
      ? isEastOverride
      : region === ResourceRegionType.East &&
        hubsViewMode !== HubsViewMode.Flat;

  // Ensure Specialists come before Devices for consistent display order
  const RESOURCE_ORDER: Record<EResourceType, number> = {
    [EResourceType.Specialist]: 0,
    [EResourceType.Device]: 1,
    [EResourceType.Surgeon]: 2,
  };

  const staffWithoutSurgeon = orderBy(
    staffInfo.filter(staff => staff.teamMemberType !== EResourceType.Surgeon),
    [staff => RESOURCE_ORDER[staff.teamMemberType] ?? 2],
  );

  const handleGroupClick = () => onClick?.(id, DrawerViewType.Hub);

  return (
    <BaseCard
      isEast={isEast}
      isFlat={hubsViewMode === HubsViewMode.Flat}
      id={id}
      className={classnames(classes[cardLocationClass])}
      onClick={handleGroupClick}
    >
      <Box className={classes.verticalColumn}>
        <Box className={classes.resourcesBox}>
          {staffWithoutSurgeon.map(staff => (
            <StaffWithCounts
              key={staff.id}
              isEast={isEast}
              staffInfo={{
                ...staff,
                countsInfo: aggregateResourcesCounts([staff]),
              }}
            />
          ))}
        </Box>
        <Box className={classes.abbreviation}>{abbreviation}</Box>
      </Box>
    </BaseCard>
  );
};
